import { render, staticRenderFns } from "./FormProfissional.vue?vue&type=template&id=3c71d5ff"
import script from "./FormProfissional.vue?vue&type=script&lang=js"
export * from "./FormProfissional.vue?vue&type=script&lang=js"
import style0 from "./FormProfissional.vue?vue&type=style&index=0&id=3c71d5ff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports